import axios from "axios";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Navigate } from "react-router-dom";


export async function dashboardcount(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/countdashboard`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listbranch(bid) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const active = bid == 1 ? "" : bid;
    return await axios
      .get(`${baseUrl}/branches?active=${bid}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listBranches() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/branches`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function createstaff(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/createstaff`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function liststaff(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/liststaff/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deletedstaff(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deletedstaff/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function allliststaff(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listallstaff/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Active staff with a known GPS position, for the dashboard tracking map.
export async function stafflocations() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/stafflocations`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function viewstaff(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/viewstaff/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deletestaff(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deletestaff/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function groupliststaff(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/staffwisegrouplist/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function groupcreate(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/creategroup`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function grouplist(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/listgroup`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
export async function deletedgroup(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/deletedgroup`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function deletedmember(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/deletedmember`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function deletedloan(id, data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/deletedloan/${id}`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function groupdetail(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .get(`${baseUrl}/viewgroup/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function groupdelete(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .get(`${baseUrl}/deletegroup/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function membercreate(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/createmember`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function memberlist(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/listmember`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function memberlistloan(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .get(`${baseUrl}/memberlistloan/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function membercloseloan(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .get(`${baseUrl}/loanclosemember/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function memberdeleteloan(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .get(`${baseUrl}/loandeletemember/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function memberdetail(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .get(`${baseUrl}/viewmember/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function memberdelete(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .get(`${baseUrl}/deletemember/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function groupmemberlist(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .get(`${baseUrl}/listgroupmember/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function loancreate(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/createloan`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function pendingloan(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/listloan/${id}`,'', { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function approveloan(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/approveloan`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function loandatewise(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/datewiseloan`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Individual Member Loan Functions
export async function individualloancreate(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/createindividualloan`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function pendingindividualloan(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/listindividualloan/${id}`, '', { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function memberlistindividualloan(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .get(`${baseUrl}/memberlistindividualloan/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function individualmemberlist(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/individualmemberlist`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function membercloseindividualloan(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .get(`${baseUrl}/individualloanClosemember/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function memberdeleteindividualloan(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .get(`${baseUrl}/individualloandeletemember/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function approveindividualloan(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/approveindividualloan`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function individualloandatewise(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/datewiseindividualloan`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function individualcollectiondatewise(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/individualcollection`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function collectiondatewise(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/groupcollection`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function collectioncreate(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/createcollection`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function collectionupdate(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/editcollection`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
export async function collectionlist(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listcollection/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function datecollectionlist(id,gid) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/datewisecollection/${id}/${gid}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function datewisegroup(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/grouplistdate`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function preloancreate(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/preloancollection`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function preloandelete(id,mid) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deletepreloan/${id}/${mid}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Auto Posting: list the unpaid dues on or before a date for a group/member.
export async function autopostingdues(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/autopostingdues`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Auto Posting: mark the confirmed dues paid and write their collections.
export async function autopostingsubmit(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/autopostingsubmit`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function collectionsheet(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/sheetcollection`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


export async function reportsummary(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/summaryreport`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function reporttopcollection(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/topcollectionlist`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function pendingcollection(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/pendinggroupreport`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function loandisburselist(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/loandisbursementlist`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function denocreate(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/denominationcreate`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function denolist() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/denominationlist`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function denodelete(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/denominationdelete/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function outstandinglist(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/outstandinglist`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function bulkgeneratepayslip(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/bulkgeneratepayslip`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function createstructure(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/createstructure`, data, { headers: header })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function liststructure(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/liststructure/${id}`, { headers: header })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function viewstructure(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/viewstructure/${id}`, { headers: header })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

export async function deletestructure(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deletestructure/${id}`, { headers: header })
      .then((response) => response.data)
      .catch((error) => catcherror(error));
  } catch (error) {
    catcherror(error);
  }
}

function catcherror(error) {
  console.log(error);
  if (error.response.status === 401) {
    localStorage.clear();
     window.location.reload();
    <Navigate to={"/login"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title:
        "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    });
  } else if (error.response.status === 0) {
    toast.error(error.message);
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (
    error.response.status !== 200 &&
    error.response.data.status === false &&
    error.response.data.code !== 200
  ) {
    toast.error(error.response.data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}

// Payslip Services
export async function createpayslip(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/createpayslip`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listpayslips(branch_id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listpayslips/${branch_id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function viewpayslip(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/viewpayslip/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deletepayslip(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deletepayslip/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function staffpayslips(staff_id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/staffpayslips/${staff_id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function updatepayslipstatus(id, data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/updatepayslipstatus/${id}`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Accounts Module Services

// Chart of Accounts
export async function createaccount(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/createaccount`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listaccounts(branch_id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listaccounts/${branch_id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listaccountsbytype(type) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listaccountsbytype/${type}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getAccountList(params) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listaccounts/${params.branch_id}`, {
        headers: header,
        params: params.account_type ? { account_type: params.account_type } : {}
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function viewaccount(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/viewaccount/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deleteaccount(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deleteaccount/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function gettrialbalance(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/trialbalance`, { headers: header, params: data })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Account Types
export async function listaccounttypes() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listaccounttypes`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listactiveaccounttypes() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listactiveaccounttypes`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function viewaccounttype(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/viewaccounttype/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function createaccounttype(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/createaccounttype`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deleteaccounttype(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deleteaccounttype/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Account Groups
export async function listaccountgroups() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listaccountgroups`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listactiveaccountgroups() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listactiveaccountgroups`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listaccountgroupsbytype(typeId) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listaccountgroupsbytype/${typeId}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function viewaccountgroup(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/viewaccountgroup/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function createaccountgroup(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/createaccountgroup`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deleteaccountgroup(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deleteaccountgroup/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Vouchers
export async function createvoucher(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/createvoucher`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listvouchers(branch_id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listvouchers/${branch_id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function viewvoucher(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/viewvoucher/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deletevoucher(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deletevoucher/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function postvoucher(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/postvoucher/${id}`, {}, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Moves existing monthly loan schedules off the old 30-day stepping and onto
// calendar months. Send dry_run to list what would move without saving.
export async function realignmonthlydues(dry_run = false) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/realignmonthlydues`,
        { dry_run: dry_run ? 1 : 0 },
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Clears the auto-generated vouchers whose collection or loan has since been
// deleted. Send dry_run to list them without removing anything.
export async function reconcilevouchers(branch_id, dry_run = false) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(
        `${baseUrl}/reconcilevouchers`,
        { branch: branch_id, dry_run: dry_run ? 1 : 0 },
        { headers: header }
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getvouchertypes() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/vouchertypes`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Bank Accounts
export async function createbankaccount(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/createbankaccount`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listbankaccounts(branch_id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listbankaccounts/${branch_id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getactivebankaccounts() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/activebankaccounts`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Bank Master
export async function listbanks() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listbanks`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function createbank(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/createbank`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deletebank(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deletebank/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Individual Collection List
export async function individualcollectionlist(branch_id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/individualcollectionlist/${branch_id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Reports
export async function getcashbook(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/cashbook`, { headers: header, params: data })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getdaybook(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/daybook`, { headers: header, params: data })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Financial Statements
export async function getprofitandloss(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/profitandloss?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getbalancesheet(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/balancesheet?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getcashflow(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/cashflow?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getgeneralledger(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/generalledger/${data.account_id}?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Financial Year Management
export async function listfinancialyears() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listfinancialyears`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function createfinancialyear(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/createfinancialyear`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function updatefinancialyear(id, data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/updatefinancialyear/${id}`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function activatefinancialyear(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/activatefinancialyear/${id}`, {}, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function closefinancialyear(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/closefinancialyear/${id}`, {}, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deletefinancialyear(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deletefinancialyear/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getyearstatistics(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/yearstatistics/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function performyearendclosing(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/yearendclosing/${id}`, {}, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Budget Management
export async function listbudgets(data = {}) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/listbudgets?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function viewbudget(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/viewbudget/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function createbudget(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/createbudget`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function updatebudget(id, data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/updatebudget/${id}`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deletebudget(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deletebudget/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getbudgetvsactual(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/budgetvsactual?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getbudgetalerts(data = {}) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/budgetalerts?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function generatemonthlybudgets(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/generatemonthlybudgets`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Fixed Assets Management
export async function listassetcategories() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/listassetcategories`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function createassetcategory(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/createassetcategory`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function updateassetcategory(id, data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/updateassetcategory/${id}`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deleteassetcategory(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deleteassetcategory/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listfixedassets(data = {}) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/listfixedassets?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function viewfixedasset(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/viewfixedasset/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function createfixedasset(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/createfixedasset`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function updatefixedasset(id, data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/updatefixedasset/${id}`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deletefixedasset(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deletefixedasset/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function recorddepreciation(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/recorddepreciation`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function recorddisposal(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/recorddisposal`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getassetregister(data = {}) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/assetregister?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getdepreciationschedule(data = {}) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/depreciationschedule?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Audit Trail
export async function getauditlogs(data = {}) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/auditlogs?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getauditstatistics(data = {}) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/auditstatistics?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getuseractivity(data = {}) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/useractivity?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Management Dashboard & KPIs
export async function getDashboardData(params) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.get(`${baseUrl}/dashboarddata`, { headers: header, params });
}

export async function getYearOverYearComparison(params) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.get(`${baseUrl}/yearoveryearcomparison`, { headers: header, params });
}

export async function getAccountGroupSummary(params) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.get(`${baseUrl}/accountgroupsummary`, { headers: header, params });
}

// Custom Report Builder
export async function getReportMetadata() {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.get(`${baseUrl}/reportmetadata`, { headers: header });
}

export async function listCustomReports() {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.get(`${baseUrl}/listcustomreports`, { headers: header });
}

export async function viewCustomReport(id) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.get(`${baseUrl}/viewcustomreport/${id}`, { headers: header });
}

export async function createCustomReport(data) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.post(`${baseUrl}/createcustomreport`, data, { headers: header });
}

export async function updateCustomReport(id, data) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.post(`${baseUrl}/updatecustomreport/${id}`, data, { headers: header });
}

export async function deleteCustomReport(id) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.get(`${baseUrl}/deletecustomreport/${id}`, { headers: header });
}

export async function executeCustomReport(id, params) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.post(`${baseUrl}/executecustomreport/${id}`, params, { headers: header });
}

export async function exportCustomReport(id, params) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.post(`${baseUrl}/exportcustomreport/${id}`, params, { headers: header });
}

// Advanced Financial Analysis
export async function getFinancialRatios(params) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.get(`${baseUrl}/financialratios`, { headers: header, params });
}

export async function getTrendAnalysis(params) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.get(`${baseUrl}/trendanalysis`, { headers: header, params });
}

export async function getComparativeAnalysis(data) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.post(`${baseUrl}/comparativeanalysis`, data, { headers: header });
}

export async function getCashFlowForecast(params) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.get(`${baseUrl}/cashflowforecast`, { headers: header, params });
}

export async function getWhatIfScenario(data) {
  const header = {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
  return await axios.post(`${baseUrl}/whatifscenario`, data, { headers: header });
}

// Permission Management Service Methods

export async function listPermissions() {
    const response = await axios.get(`${baseUrl}listpermissions`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listRoles() {
    const response = await axios.get(`${baseUrl}listroles`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listRolePermissions(roleId) {
    const response = await axios.get(`${baseUrl}listrolepermissions/${roleId}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function assignPermissionsToRole(roleId, data) {
    const response = await axios.post(`${baseUrl}assignpermissionstorole/${roleId}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listUsers() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/users`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function listUserPermissions(userId) {
    const response = await axios.get(`${baseUrl}listuserpermissions/${userId}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function grantUserPermission(userId, data) {
    const response = await axios.post(`${baseUrl}grantuserpermission/${userId}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function revokeUserPermission(userId, data) {
    const response = await axios.post(`${baseUrl}revokeuserpermission/${userId}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listUserBranchAccess(userId) {
    const response = await axios.get(`${baseUrl}listuserbranchaccess/${userId}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function manageBranchAccess(userId, data) {
    const response = await axios.post(`${baseUrl}managebranchaccess/${userId}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listApprovalWorkflows(params) {
    const response = await axios.get(`${baseUrl}listapprovalworkflows`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createApprovalWorkflow(data) {
    const response = await axios.post(`${baseUrl}createapprovalworkflow`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function updateApprovalWorkflow(id, data) {
    const response = await axios.post(`${baseUrl}updateapprovalworkflow/${id}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function deleteApprovalWorkflow(id) {
    const response = await axios.get(`${baseUrl}deleteapprovalworkflow/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listPendingApprovals(userId) {
    const response = await axios.get(`${baseUrl}listpendingapprovals/${userId}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listApprovalRequests(params) {
    const response = await axios.get(`${baseUrl}listapprovalrequests`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function processApproval(requestId, data) {
    const response = await axios.post(`${baseUrl}processapproval/${requestId}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getApprovalRequestDetails(requestId) {
    const response = await axios.get(`${baseUrl}approvalrequestdetails/${requestId}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}


// Tax Management Service Methods

export async function listTaxConfigurations(params) {
    const response = await axios.get(`${baseUrl}listtaxconfigurations`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createTaxConfiguration(data) {
    const response = await axios.post(`${baseUrl}createtaxconfiguration`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function updateTaxConfiguration(id, data) {
    const response = await axios.post(`${baseUrl}updatetaxconfiguration/${id}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function deleteTaxConfiguration(id) {
    const response = await axios.get(`${baseUrl}deletetaxconfiguration/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listTaxGroups() {
    const response = await axios.get(`${baseUrl}listtaxgroups`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createTaxGroup(data) {
    const response = await axios.post(`${baseUrl}createtaxgroup`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getTaxReport(params) {
    const response = await axios.get(`${baseUrl}gettaxreport`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listTdsDeductions(params) {
    const response = await axios.get(`${baseUrl}listtdsdeductions`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createTdsDeduction(data) {
    const response = await axios.post(`${baseUrl}createtdsdeduction`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function updateTdsDeduction(id, data) {
    const response = await axios.post(`${baseUrl}updatetdsdeduction/${id}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function generateTdsCertificate(id) {
    const response = await axios.get(`${baseUrl}generatetdscertificate/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listGstReturns(params) {
    const response = await axios.get(`${baseUrl}listgstreturns`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function generateGstReturn(data) {
    const response = await axios.post(`${baseUrl}generategstreturn`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function fileGstReturn(id, data) {
    const response = await axios.post(`${baseUrl}filegstreturn/${id}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listTaxPayments(params) {
    const response = await axios.get(`${baseUrl}listtaxpayments`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createTaxPayment(data) {
    const response = await axios.post(`${baseUrl}createtaxpayment`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listHsnSacCodes(params) {
    const response = await axios.get(`${baseUrl}listhsnsaccodes`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createHsnSacCode(data) {
    const response = await axios.post(`${baseUrl}createhsnsaccode`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}


// RBI / NBFC Compliance Summary (clean, single-wrapped payload)
export async function getRbiNbfcCompliance(data = {}) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/getrbinbfccompliance?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}


// Data Backup & Recovery Service Methods

export async function listBackups(params) {
    const response = await axios.get(`${baseUrl}listbackups`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createBackup(data) {
    const response = await axios.post(`${baseUrl}createbackup`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function downloadBackup(id) {
    const response = await axios.get(`${baseUrl}downloadbackup/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        },
        responseType: 'blob'
    });
    return response;
}

export async function deleteBackup(id) {
    const response = await axios.get(`${baseUrl}deletebackup/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function restoreBackup(id) {
    const response = await axios.post(`${baseUrl}restorebackup/${id}`, {}, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function listBackupSchedules() {
    const response = await axios.get(`${baseUrl}listbackupschedules`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createBackupSchedule(data) {
    const response = await axios.post(`${baseUrl}createbackupschedule`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function updateBackupSchedule(id, data) {
    const response = await axios.post(`${baseUrl}updatebackupschedule/${id}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function deleteBackupSchedule(id) {
    const response = await axios.get(`${baseUrl}deletebackupschedule/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getDatabaseTables() {
    const response = await axios.get(`${baseUrl}getdatabasetables`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}


// System Security Service Methods

export async function getLoginHistory(params) {
    const response = await axios.get(`${baseUrl}getloginhistory`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getSecurityStatistics(params) {
    const response = await axios.get(`${baseUrl}getsecuritystatistics`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getSecurityAlerts(params) {
    const response = await axios.get(`${baseUrl}getsecurityalerts`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createSecurityAlert(data) {
    const response = await axios.post(`${baseUrl}createsecurityalert`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function resolveSecurityAlert(id) {
    const response = await axios.post(`${baseUrl}resolvesecurityalert/${id}`, {}, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function markAlertAsRead(id) {
    const response = await axios.post(`${baseUrl}markalertasread/${id}`, {}, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getSecuritySettings() {
    const response = await axios.get(`${baseUrl}getsecuritysettings`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function updateSecuritySetting(id, data) {
    const response = await axios.post(`${baseUrl}updatesecuritysetting/${id}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function forceLogoutUser(userId) {
    const response = await axios.post(`${baseUrl}forcelogoutuser/${userId}`, {}, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function changeUserPassword(userId, data) {
    const response = await axios.post(`${baseUrl}changeuserpassword/${userId}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getIpWhitelist() {
    const response = await axios.get(`${baseUrl}getipwhitelist`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function addIpToWhitelist(data) {
    const response = await axios.post(`${baseUrl}addiptowhitelist`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function removeIpFromWhitelist(id) {
    const response = await axios.get(`${baseUrl}removeipfromwhitelist/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getActiveSessions() {
    const response = await axios.get(`${baseUrl}getactivesessions`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

// Notification services
export async function getTemplates(params) {
    const response = await axios.get(`${baseUrl}gettemplates`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createTemplate(data) {
    const response = await axios.post(`${baseUrl}createtemplate`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function updateTemplate(id, data) {
    const response = await axios.post(`${baseUrl}updatetemplate/${id}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function deleteTemplate(id) {
    const response = await axios.delete(`${baseUrl}deletetemplate/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function sendNotification(data) {
    const response = await axios.post(`${baseUrl}sendnotification`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function sendBulkNotification(data) {
    const response = await axios.post(`${baseUrl}sendbulknotification`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getNotificationLogs(params) {
    const response = await axios.get(`${baseUrl}getnotificationlogs`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getNotificationStatistics(params) {
    const response = await axios.get(`${baseUrl}getnotificationstatistics`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getScheduledNotifications(params) {
    const response = await axios.get(`${baseUrl}getschedulednotifications`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createScheduledNotification(data) {
    const response = await axios.post(`${baseUrl}createschedulednotification`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function updateScheduledNotification(id, data) {
    const response = await axios.post(`${baseUrl}updateschedulednotification/${id}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function deleteScheduledNotification(id) {
    const response = await axios.delete(`${baseUrl}deleteschedulednotification/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function retryNotification(id) {
    const response = await axios.post(`${baseUrl}retrynotification/${id}`, {}, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

// Import/Export services
export async function getImportTemplates(params) {
    const response = await axios.get(`${baseUrl}getimporttemplates`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function downloadImportTemplate(type) {
    const response = await axios.get(`${baseUrl}downloadimporttemplate/${type}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        },
        responseType: 'blob'
    });
    return response;
}

export async function uploadImportFile(formData) {
    const response = await axios.post(`${baseUrl}uploadimportfile`, formData, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}

export async function processImport(importLogId) {
    const response = await axios.post(`${baseUrl}processimport/${importLogId}`, {}, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getImportLogs(params) {
    const response = await axios.get(`${baseUrl}getimportlogs`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function deleteImportLog(id) {
    const response = await axios.delete(`${baseUrl}deleteimportlog/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function exportData(data) {
    const response = await axios.post(`${baseUrl}exportdata`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function downloadExport(exportLogId) {
    const response = await axios.get(`${baseUrl}downloadexport/${exportLogId}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        },
        responseType: 'blob'
    });
    return response;
}

export async function getExportLogs(params) {
    const response = await axios.get(`${baseUrl}getexportlogs`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function deleteExportLog(id) {
    const response = await axios.delete(`${baseUrl}deleteexportlog/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

// Recurring Transaction services
export async function getRecurringTransactions(params) {
    const response = await axios.get(`${baseUrl}getrecurringtransactions`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createRecurringTransaction(data) {
    const response = await axios.post(`${baseUrl}createrecurringtransaction`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function updateRecurringTransaction(id, data) {
    const response = await axios.post(`${baseUrl}updaterecurringtransaction/${id}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function deleteRecurringTransaction(id) {
    const response = await axios.delete(`${baseUrl}deleterecurringtransaction/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function executeRecurringTransaction(id) {
    const response = await axios.post(`${baseUrl}executerecurringtransaction/${id}`, {}, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getDueTransactions(params) {
    const response = await axios.get(`${baseUrl}getduetransactions`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function processDueTransactions(data) {
    const response = await axios.post(`${baseUrl}processduetransactions`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getTransactionHistory(id) {
    const response = await axios.get(`${baseUrl}gettransactionhistory/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getRecurringTemplates() {
    const response = await axios.get(`${baseUrl}getrecurringtemplates`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function pauseRecurringTransaction(id) {
    const response = await axios.post(`${baseUrl}pauserecurringtransaction/${id}`, {}, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function resumeRecurringTransaction(id) {
    const response = await axios.post(`${baseUrl}resumerecurringtransaction/${id}`, {}, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

// Bank Reconciliation services
export async function uploadBankStatement(formData) {
    const response = await axios.post(`${baseUrl}uploadbankstatement`, formData, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
}

export async function processBankStatement(importId) {
    const response = await axios.post(`${baseUrl}processbankstatement/${importId}`, {}, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getBankImports(params) {
    const response = await axios.get(`${baseUrl}getbankimports`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getImportTransactions(importId) {
    const response = await axios.get(`${baseUrl}getimporttransactions/${importId}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function matchTransaction(transactionId, data) {
    const response = await axios.post(`${baseUrl}matchtransaction/${transactionId}`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function unmatchTransaction(transactionId) {
    const response = await axios.post(`${baseUrl}unmatchtransaction/${transactionId}`, {}, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function getReconciliationSessions(params) {
    const response = await axios.get(`${baseUrl}getreconciliationsessions`, {
        params: params,
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function createReconciliationSession(data) {
    const response = await axios.post(`${baseUrl}createreconciliationsession`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function deleteBankImport(id) {
    const response = await axios.delete(`${baseUrl}deletebankimport/${id}`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}


// Financial Years
export async function getfinancialyears() {
    const response = await axios.get(`${baseUrl}/getfinancialyears`, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

// Migrate Loans to Accounting
export async function getmigrationcount(data) {
    const response = await axios.post(`${baseUrl}/getmigrationcount`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}

export async function migrateloanstoaccounting(data) {
    const response = await axios.post(`${baseUrl}/migrateloanstoaccounting`, data, {
        headers: {
            'Authorization': "Bearer " + localStorage.getItem("token"),
        }
    });
    return response.data;
}


export async function getIndividualReportData(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/individualreportdata`,data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// Job Allocation Functions
export async function listjoballocations(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
        Role: localStorage.getItem("Role"),
    };
    const params = new URLSearchParams(data).toString();
    return await axios
      .get(`${baseUrl}/listjoballocations?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function createjoballocation(data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
    };
    return await axios
      .post(`${baseUrl}/createjoballocation`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function viewjoballocation(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/viewjoballocation/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function updateverification(id, data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/updateverification/${id}`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function approveallocation(id, data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/approveallocation/${id}`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function rejectallocation(id, data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/rejectallocation/${id}`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function updateallocationstatus(id, data) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .post(`${baseUrl}/updateallocationstatus/${id}`, data, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deletejoballocation(id) {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    return await axios
      .get(`${baseUrl}/deletejoballocation/${id}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getstafflist() {
  try {
    const header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
    };
    const branchId = localStorage.getItem("branch") || "";
    const params = new URLSearchParams({ branch_id: branchId }).toString();
    return await axios
      .get(`${baseUrl}/getstafflist?${params}`, { headers: header })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}
